import Header from "components/Headers/Header";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { get_platform_list, get_universes_list } from "utils/Commen";
import { useEffect, useRef, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import clsx from "clsx";
import { updateAnime } from "utils/endpoint";
import UseFullPageLoader from "utils/UseFullPageLoader";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { deleteAnimeComment } from "utils/endpoint";
import { Modal } from "antd";
import { getAnimeById } from "utils/endpoint";
import { RiDeleteBin6Line } from "react-icons/ri";
import CreateUniverses from "utils/CreateUniverses";
import useSearchParams from "utils/useSearchParams";
import { CSVLink } from "react-csv";
import moment from "moment";
import { genrateCsvFileName } from "utils/Commen";
import { dubChoice, datePrecision } from "utils/enums";
import ProtectedRoute from "components/ProtectedRoute";


const validationSchema = yup.object({
  en_title: yup.string().required("EN Title is required"),
});

export const headers = [
  { label: "EN Title", key: "en_title" },
  { label: "Universe Name", key: "universe_name" },
  { label: "JP Publisher", key: "licensor" },
  { label: "Studio", key: "studio" },
  { label: "Studio Link", key: "studio_link" },
  { label: "No Of Episodes", key: "no_of_episodes" },
  { label: "Platforms", key: "platforms" },
  { label: "Ratings", key: "ratings" },
  { label: "Vod Link", key: "vod_link" },
  { label: "Rel. Date", key: "rel_date" },
  { label: "Rel. Date Precision", key: "rel_date_precision" },
  { label: "EN Dub", key: "en_dub" },
  { label: "FR Dub", key: "fr_dub" },
  { label: "Comments", key: "comment" },
  { label: "CreatedAt", key: "created_at" },
];

export const getData = (data) => {
  const animeData = [{
    en_title: data?.en_title,
    universe_name: data?.universe_name,
    licensor: data?.licensor,
    studio: data?.studio,
    studio_link: data?.studio_link,
    no_of_episodes: data?.no_of_episodes,
    platforms: data?.platforms,
    ratings: data?.ratings,
    vod_link: data?.vod_link,
    rel_date: data?.rel_date,
    rel_date_precision: data?.rel_date_precision,
    en_dub: data?.en_dub,
    fr_dub: data?.fr_dub,
    comment: data?.comment,
    created_at: moment(data?.created_at).format("YYYY-MM-DD HH:mm:ss")
  }];

  return animeData
}

const UpdateAnime = () => {
  const { state } = useLocation();
  const [animeQueryParams, setAnimeQueryParams] = useSearchParams();
  const currentPage = animeQueryParams.currentPage;
  const enTitle = animeQueryParams.enTitle;
  const fromDate = animeQueryParams.fromDate;
  const toDate = animeQueryParams.toDate;
  const userIdString = animeQueryParams.userIdString;
  const universeIdString = animeQueryParams.universeIdString;
  const is_active = animeQueryParams.is_active;
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [universeList, setUniverseList] = useState([]);
  const [platformList, setPlatformList] = useState([]);
  const [currentComment, setCurrentComment] = useState(state.row.comment);
  const [show, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [csvData, setCsvData] = useState([])
  const [anime, setAnime] = useState(state.row);

  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const inputRef = useRef(null);

  const loginData = localStorage.getItem("User");
  const loginUser = JSON.parse(loginData);

  const getUniverseList = async () => {
    const allUniverses = await get_universes_list();
    setUniverseList([{ id: '', name: 'None' }, ...allUniverses]);
  };

  const { confirm } = Modal;
  const animeId = state.row.id;

  const handleDeleteAnimeComment = async () => {
    try {
      inputRef.current.value = '';
      const response = await deleteAnimeComment(animeId);
      if (response.isSuccess) {
        toast.success(`${response.message}`);
      }
    } catch (error) {
      toast.error(`${error.message}`);
    }
  };

  const showDeleteConfirm = () => {
    confirm({
      title: "Are you sure delete this comment ?",
      icon: <ExclamationCircleFilled />,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleDeleteAnimeComment();
      },
    });
  };

  const handleSearchParams = () => {
    const url = new URL('/admin/anime/anime-list', window.location.origin);
    const params = new URLSearchParams(url.search);

    // Required param
    if (id) params.set('id', id);

    // Optional params
    if (currentPage) params.set('page', currentPage);
    if (enTitle) params.set('en_title', enTitle);
    if (fromDate) params.set('from_date', fromDate);
    if (toDate) params.set('to_date', toDate);
    if (universeIdString) params.set('universe_id', universeIdString);
    if (userIdString) params.set('user_id', userIdString);

    // Handle is_active
    if (is_active !== undefined) {
      const value =
        is_active === 'true'
          ? 'true'
          : is_active === 'none'
            ? 'none'
            : 'false';
      params.set('is_active', value);
    }

    url.search = params.toString();

    // Return only relative URL
    return url.toString().replace(window.location.origin, '');
  };



  const getPlatformList = async () => {
    const allPlatforms = await get_platform_list();
    setPlatformList(allPlatforms);
  };

  useEffect(() => {
    getUniverseList();
    getPlatformList();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getAnimeById({
          anime_id: animeId,
        });
        if (response && response.isSuccess) {
          setCurrentComment(response.data.comment)
          setAnime(response.data)
        }
      } catch (error) {
        toast.error(`${error.message}`);
      }
    })();
  }, []);

  useEffect(() => {
    const data = getData(anime)
    setCsvData(data)
  }, [])


  return (
    <Formik
      enableReinitialize
      initialValues={{
        en_title: anime?.en_title,
        universe_id: anime?.universe_id ?? "",
        universe_name: anime?.universe_name ?? "None",
        no_of_episodes: anime?.no_of_episodes,
        vod_in_france: anime?.vod_in_france,
        vod_link: anime?.vod_link,
        studio: anime?.studio ?? "",
        studio_link: anime?.studio_link ?? "",
        ratings: anime?.ratings ?? "",
        rel_date: anime?.rel_date ?? "",
        rel_date_precision: anime?.rel_date_precision ?? "EXACT",
        en_dub: anime?.en_dub ?? "",
        fr_dub: anime?.fr_dub ?? "",
        platform_ids: anime?.platform_ids ?? [],
        comment: currentComment,
        is_active: anime?.is_active,
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        setLoading(true);
        showLoader()
        const updateData = {
          en_title: values.en_title,
          universe_id: values.universe_id ? values.universe_id : null,
          no_of_episodes: values.no_of_episodes,
          vod_in_france: values.vod_in_france,
          vod_link: values.vod_link,
          studio: values.studio,
          studio_link: values.studio_link,
          ratings: values.ratings,
          rel_date: values.rel_date,
          rel_date_precision: values.rel_date_precision,
          en_dub: values.en_dub,
          fr_dub: values.fr_dub,
          platform_ids: values.platform_ids,
          comment: values.comment,
          is_active: values.is_active,
        };
        const result = await updateAnime(id, updateData);
        if (result?.isSuccess) {
          toast.success("Anime Updated successfully");
          setLoading(false);
          hideLoader()
          resetForm();
          // const url = handleSearchParams()
          // navigate(url);
          navigate(`/admin/anime/view-anime/${id}`);
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader()
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}>
      {({
        handleChange,
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Update Anime</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <CSVLink
                            data={csvData}
                            headers={headers}
                            filename={genrateCsvFileName(`anime_${anime.en_title}`)}
                            className="btn btn-primary"
                            target="_blank"
                          >
                            Export to CSV
                          </CSVLink>

                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              const url = handleSearchParams()
                              navigate(url);
                            }}>
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>

                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label required">
                              EN Title ({anime?.update_history?.en_title})
                            </label>
                            <Input
                              className={clsx("form-control", {
                                "is-invalid":
                                  Boolean(errors.en_title) && touched.en_title,
                              })}
                              id="en_title"
                              name="en_title"
                              placeholder="EN Title"
                              type="text"
                              value={values.en_title}
                              onChange={handleChange}
                            />
                            <div className="text-danger text-align-top-center mt-1">
                              <ErrorMessage name="en_title" />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <div className="d-flex justify-content-between">
                              <label className="form-control-label">
                                Universe ({anime?.update_history?.universe_id})
                              </label>
                              <Button
                                className="btn-sm ml-10 text-right"
                                color="primary"
                                onClick={async () => {
                                  setShowModal(true);
                                }}>
                                +
                              </Button>
                            </div>
                            <Select
                              defaultValue={{
                                label: values.universe_name,
                                value: values.universe_id,
                              }}
                              name="universe_id"
                              id="universe_id"
                              className="react-select mt-1"
                              classNamePrefix="my-react-select"
                              options={Array.from(universeList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("universe_id", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              No. Off Episodes ({anime?.update_history?.no_of_episodes})
                            </label>
                            <Input
                              className="form-control"
                              id="no_of_episodes"
                              name="no_of_episodes"
                              placeholder="No. Off Episodes"
                              type="number"
                              onChange={handleChange}
                              value={values.no_of_episodes === null ? '' : values.no_of_episodes}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Studio ({anime?.update_history?.studio})
                            </label>
                            <Input
                              className="form-control"
                              id="studio"
                              name="studio"
                              placeholder="Studio"
                              type="text"
                              value={values.studio === null ? '' : values.studio}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Studio Link ({anime?.update_history?.studio_link})
                            </label>
                            <Input
                              className="form-control"
                              id="studio_link"
                              name="studio_link"
                              placeholder="Studio Link"
                              type="text"
                              value={values.studio_link === null ? '' : values.studio_link}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Ratings ({anime?.update_history?.ratings})
                            </label>
                            <Input
                              className="form-control"
                              id="ratings"
                              name="ratings"
                              placeholder="Ratings"
                              type="number"
                              value={values.ratings === null ? '' : values.ratings}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Rel. Date Precision ({anime?.update_history?.rel_date_precision})
                            </label>
                            <Select
                              value={datePrecision.find(x => x.id === values.rel_date_precision)}
                              name="rel_date_precision"
                              id="rel_date_precision"
                              className=""
                              options={Array.from(datePrecision).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("rel_date_precision", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Rel. Date ({anime?.update_history?.rel_date})
                            </label>
                            <Input
                              className="form-control"
                              id="rel_date"
                              name="rel_date"
                              placeholder="Rel. Date"
                              type="date"
                              value={values.rel_date === null ? '' : values.rel_date}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              EN Dub ({anime?.update_history?.en_dub})
                            </label>
                            <Select
                              value={dubChoice.find(x => x.id === values.en_dub)}
                              name="en_dub"
                              id="en_dub"
                              className=""
                              options={Array.from(dubChoice).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("en_dub", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              FR Dub ({anime?.update_history?.fr_dub})
                            </label>
                            <Select
                              value={dubChoice.find(x => x.id === values.fr_dub)}
                              name="fr_dub"
                              id="fr_dub"
                              className=""
                              options={Array.from(dubChoice).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("fr_dub", event.value);
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              VoD in France ({anime?.update_history?.vod_in_france})
                            </label>
                            <Select
                              name="platform_ids"
                              id="platform_ids"
                              isMulti
                              className="react-select mt-1"
                              value={platformList.filter(p => values.platform_ids?.includes(p.id)).map(p => ({ value: p.id, label: p.name }))}
                              options={Array.from(platformList).map((value) => {
                                return {
                                  value: value.id,
                                  label: value.name,
                                };
                              })}
                              onChange={(event) => {
                                setFieldValue("platform_ids", event.map(x => x.value));
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Link VoD ({anime?.update_history?.vod_link})
                            </label>
                            <Input
                              className="form-control"
                              id="vod_link"
                              name="vod_link"
                              placeholder="Link VoD"
                              type="text"
                              value={values.vod_link === null ? '' : values.vod_link}

                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label">
                              Comments ({loginUser.user?.first_name}{" "}
                              {loginUser.user?.last_name})
                              {values.comment && <RiDeleteBin6Line
                                onClick={showDeleteConfirm}
                                className="ml-19"
                                style={{ cursor: "pointer" }}
                                size={26}
                              />}
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="comments..."
                              type="text"
                              name="comment"
                              id="comment"
                              value={values.comment}
                              onChange={(event) => {
                                if (event.target.value.trim() !== '') {
                                  setFieldValue(
                                    "comment",
                                    event.target.value
                                  );
                                } else {
                                  setFieldValue('comment', '');
                                }
                              }}
                              rows={2}
                              ref={inputRef}
                              cols={40}></textarea>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="3">
                          <label className="form-control-label">
                            All Comments
                          </label>
                        </Col>
                      </Row>
                      <Row>
                        {anime?.all_comments?.length > 0 ? (
                          anime.all_comments.map((x) => (
                            <>
                              <Col lg="3">
                                <li className="fs-5 text-dark">
                                  {x.first_name} {x.last_name}
                                </li>

                                <textarea
                                  className="form-control"
                                  type="text"
                                  name="all_comments"
                                  value={x.comment}
                                  onChange={handleChange}
                                  rows={2}
                                  disabled
                                  cols={40}></textarea>
                              </Col>
                            </>
                          ))
                        ) : (
                          <>
                            <div>No Comments</div>
                          </>
                        )}
                      </Row>
                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary">
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}>
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">
                                Update Anime
                              </span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
              <CreateUniverses
                show={show}
                mediaType={"ANIME"}
                onClose={() => {
                  getUniverseList();
                  setShowModal(false);
                }}
              />
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
};

export default () => (
  <ProtectedRoute requiredPermissions="update-anime">
    <UpdateAnime />
  </ProtectedRoute>
);
